import React, { useContext } from 'react';
import { AddVehicle } from '../components/vehicle-manager/components/add-vehicle';
import { PortalContext } from '../context/portal-context';
import { useUniversalEffect } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { usePageTracker } from '../hooks/use-page-tracker';
import { ClubVolkswagenPagesInfo, ClubVolkswagenPages } from './model/club-volkswagen-pages-info';
import { useAlertVehicleManagerLayer } from '../components/vehicle-manager/hooks/use-alert-vehicle-manager-layer';

export const AddVehiclePage: React.FC<{
	registerToClub?: boolean;
}> = ({ registerToClub }) => {
	const { pageInfoService } = useContext(PortalContext);
	const { handleLayerOpen: handleAlertLayerOpen } = useAlertVehicleManagerLayer();
	const pageInfo = ClubVolkswagenPagesInfo[ClubVolkswagenPages.AddVehiclePage];

	useUniversalEffect(() => {
		pageInfoService.setPageInfo({
			seo: { pageTitle: pageInfo.seoTitle },
		});
	}, [pageInfoService]);

	usePageTracker({ contentId: pageInfo.contentId });

	return <AddVehicle registerToClub={registerToClub} onError={handleAlertLayerOpen} />;
};
